<template>
	
	<div class="message_list clearfix p_background">
		<h3 class="all_title">全部消息</h3>
		<section class="all_container container_box">
			<input v-model="status" type="hidden"/>
			<!--all state start-->
			<div class="all_state clearfix">
				<div class="state_left">
					<ul>
						<li :class="{msg_active : classFlag}" @click="getMessageList('')">全部消息</li>
						<li :class="{msg_active : classFlag1}" @click="getMessageList(0)">未读消息({{msgCount}})</li>
					</ul>
				</div>
			</div>
			<!--all state end-->
			
			<!--table start-->
			<div class="table_box table_a clearfix">
				<table class="table table-hover text-center">
					<thead>
						<tr>
							<th>消息标题</th>
							<th>发布时间</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(message,index) in page.content">
							<td>
								<span class="unread" v-if="message.messageStatus == 0"></span>
								<a @click="view(message.id)" class="cursor">{{message.messageTitle}}</a>
							</td>
							<td>{{message.messageSendTime | datetime}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!--table end-->
			<div class="text-center" v-bind:class="page.totalPages &gt; 0 ? 'show' : 'hidden'">
				<div class="row-fluid">
					<el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.total">
                    </el-pagination>
				</div>
			</div>
		</section>
	</div>
	
</template>

<script>
	export default {
	  name: 'message_list',
	  data () {
	    return {
	      currentPage:1,
	      pageSize:10,
	      msgCount: '',
	      page:'',
	      status:'',
	      classFlag1: false,
	      classFlag: false,
	    }
	  },
	  // 页面初始化
	  created: function(){
	  		//初始化获取消息列表方法
			this.getMessageList('');
			//初始化获取未读消息的总条数方法
			this.getMCount();
	  },
	  methods:{
	  	//获取消息列表
	    getMessageList(status){
	    	console.log(sessionStorage.getItem("msglist_status"))
	    	if(!!sessionStorage.getItem("msglist_currentPage")){
	    		this.currentPage = parseInt(sessionStorage.getItem("msglist_currentPage"));
		    	this.pageSize = parseInt(sessionStorage.getItem("msglist_pageSize"));
		    	this.status = sessionStorage.getItem("msglist_status");
		    	
		    	sessionStorage.removeItem("msglist_currentPage");
		    	sessionStorage.removeItem("msglist_pageSize");
		    	sessionStorage.removeItem("msglist_status");
	    	}
	    	
	    	var temp = this;
	    	var loginType=this.$store.getters.getUserType;
	    	this.status=status;
	    	if(status == '0'){
	    		this.classFlag = false
	    		this.classFlag1 = true
	    	}else {
	    		this.classFlag = true
	    		this.classFlag1 = false
	    	}
	    	$(this).addClass("msg_active").siblings().removeClass("msg_active")
	      	this.$http.post('/zklccloud/findTCloudMessages',{"userType":loginType,"messageType":1,"messageStatus":status,"page": this.currentPage - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
	      		temp.page = m.data.content.page
	      })
	    },
	    handleSizeChange(val) {
			var loginType=this.$store.getters.getUserType;
        	this.pageSize = val;
        	this.currentPage = 1;
            var temp = this;
            this.$http.post('/zklccloud/findTCloudMessages',{"userType":loginType,"messageType":1,"messageStatus":this.status,"page": this.currentPage - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
		      	temp.page = m.data.content.page
		    })
        },
        handleCurrentChange(val) {
        	this.currentPage = val;
            var temp = this;
            var loginType=this.$store.getters.getUserType;
            this.$http.post('/zklccloud/findTCloudMessages',{"userType":loginType,"messageType":1,"messageStatus":this.status,"page": val - 1,"size":this.pageSize},{emulateJSON:true}).then(function(m){
		      	temp.page = m.data.content.page
		    })
       },
	    //根据id查询消息详情
	    view(id){
	    	sessionStorage.setItem("msglist_currentPage",this.currentPage);
	    	sessionStorage.setItem("msglist_pageSize",this.pageSize);
	    	sessionStorage.setItem("msglist_status",this.status);
	    	this.$router.push({name:'read_message',params:{messageId:id}});
	    },
	    //获取未读消息的总条数
	    getMCount(){
	    	var temp = this;
	    	var loginType=this.$store.getters.getUserType;
	      	this.$http.post('/zklccloud/findTCloudMessagesCount',{"userType":loginType,"messageType":1,"messageStatus":0},{emulateJSON:true}).then(function(m){
	      		temp.msgCount = m.body.data
	      })
	    }
	  },
	}
</script>

<style scoped>
	.unread {
		display: inline-block;
		vertical-align: middle;
		width: 8px;
		height: 8px;
		background-color: red;
		border-radius: 50%;
	}
	.msg_active {
		color: #2993FF;
	}
</style>


// WEBPACK FOOTER //
// message_list.vue?d7ca0df2